import React, { useMemo, useState } from "react"
import WbsRow from "./WbsRow"

const collectParentIds = (tasks, acc = []) => {
  tasks.forEach(t => {
    if (t.children_count > 0 && t.children?.length > 0) {
      acc.push(t.id)
      collectParentIds(t.children, acc)
    }
  })
  return acc
}

const WbsTree = ({ tasks, project }) => {
  const [collapsed, setCollapsed] = useState(() => new Set())

  const parentIds  = useMemo(() => collectParentIds(tasks), [tasks])
  const allClosed  = parentIds.length > 0 && parentIds.every(id => collapsed.has(id))

  const toggle = id => {
    setCollapsed(prev => {
      const next = new Set(prev)
      next.has(id) ? next.delete(id) : next.add(id)
      return next
    })
  }
  const toggleAll = () => {
    setCollapsed(allClosed ? new Set() : new Set(parentIds))
  }

  return (
    <section id="section-wbs" className="px-7 scroll-mt-24">
      <header className="pl-[16px] flex items-end justify-between mb-3 gap-3 flex-wrap">
        <div>
          <h2 className="text-[15px] font-semibold text-slate-900">{I18n.t("projects.wbs.title")}</h2>
          <p className="text-[12.5px] text-slate-500 mt-0.5">{I18n.t("projects.wbs.subtitle")}</p>
        </div>
      </header>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
          <div className="grid grid-cols-[minmax(220px,2fr)_110px_180px_110px_110px_120px_60px] gap-3 px-3 py-2 bg-slate-50 border-b border-slate-200 text-[10.5px] uppercase tracking-wider text-slate-500 font-medium">
            <div className="flex items-center gap-1.5">
              <button
                type="button"
                onClick={toggleAll}
                disabled={parentIds.length === 0}
                aria-label={allClosed ? I18n.t("projects.tasks.expand_all") : I18n.t("projects.wbs.collapse_all")}
                title={allClosed ? I18n.t("projects.tasks.expand_all") : I18n.t("projects.wbs.collapse_all")}
                className="inline-grid place-items-center w-5 h-5 rounded text-slate-400 hover:bg-slate-200 hover:text-slate-700 disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                     className={`transition-transform ${allClosed ? "" : "rotate-90"}`}>
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
              <span>{I18n.t("projects.tasks.task")}</span>
            </div>
            <div>{I18n.t("projects.status")}</div>
            <div>{I18n.t("projects.assignee")}</div>
            <div>{I18n.t("projects.wbs.start")}</div>
            <div>{I18n.t("projects.wbs.end")}</div>
            <div>{I18n.t("projects.completion")}</div>
            <div />
          </div>

        <div className="divide-y divide-slate-100">
          {tasks.length === 0 ? (
            <div className="px-6 py-12 text-center text-[13px] text-slate-500">
              {I18n.t("projects.wbs.empty")}
            </div>
          ) : tasks.map(task => (
            <WbsRow key={task.id} task={task} project={project} depth={0} collapsed={collapsed} onToggle={toggle} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default WbsTree
